import React from "react";
import { Field } from "formik";
import { isFunction } from "lodash";

const validateField = value => {
  let error;
  if (!value) {
    error = "Password is required";
  }
  return error;
};

class Password extends React.PureComponent {
  render() {
    const { name, validate, title, errors, submitCount, touched } = this.props;

    let className =
      (errors[name] && (touched[name] || !!submitCount)
        ? "error is-invalid"
        : "") + " text-input form-control";

    return (
      <React.Fragment>
        {title &&  <label>{title}</label>}
        <div className="input-group mb-3">
          <Field
            name={name}
            className={className}
            {...this.props}
            validate={isFunction(validate) ? validate : validateField}
          />
          {errors[name] && touched[name] && (
            <div className="invalid-feedback">{errors[name]}</div>
          )}
        </div>
      </React.Fragment>
    );
  }
}

export default Password;
